import PropTypes from 'prop-types';
import React from 'react';

import { EditorBlock, EditorState, SelectionState } from 'draft-js';

import { getCurrentBlock } from 'medium-draft/lib/model';

import { strMapToObj } from '../../helpers';

export default class ImageBlock extends React.Component {
  static propTypes = {
    block: PropTypes.object, // eslint-disable-line
    blockProps: PropTypes.object, // eslint-disable-line
  };

  focusBlock = () => {
    const { block, blockProps } = this.props;
    const { getEditorState, setEditorState } = blockProps;
    const key = block.getKey();
    const editorState = getEditorState();
    const currentblock = getCurrentBlock(editorState);
    if (currentblock.getKey() === key) {
      return;
    }
    const newSelection = new SelectionState({
      anchorKey: key,
      focusKey: key,
      anchorOffset: 0,
      focusOffset: 0,
    });
    setEditorState(EditorState.forceSelection(editorState, newSelection));
  };

  render() {
    const { block } = this.props;
    const data = block.getData();
    const src = data.get('src');
    const attributes = strMapToObj(data);
    if (src !== null) {
      return (
        <div>
          <div
            data-test-id="hp7hCcatvdkli5hljq3xn"
            className="md-block-image-inner-container"
            role="button"
            onClick={this.focusBlock}
            onKeyPress={this.focusBlock}
            tabIndex={0}
          >
            <img // eslint-disable-line jsx-a11y/alt-text
              {...attributes}
            />
          </div>
          <figcaption>
            <EditorBlock {...this.props} />
          </figcaption>
        </div>
      );
    }
    return <EditorBlock {...this.props} />;
  }
}
